module.exports = __webpack_public_path__ + "static/dumbellrattles1-3f533ab1137f86ffbc17072708aa5b2d.jpeg";